import { MenuItem } from "@chakra-ui/react";
import { useWaterfallConfigTableRetrieveSuspense } from "gen/endpoints/waterfall/waterfall";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useTranslation } from "react-i18next";
import { Restricted } from "shared/components/access/Restricted";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxActionsMenu } from "shared/components/table/box/TableBoxActionsMenu";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";

interface WaterfallConfigSummaryTableProps {
  readOnly?: boolean;
  fundFamilyId: string;
  commitmentId?: string;
  investorClassId?: string;
  fundId?: string;
  startEditing: () => void;
  isEditing: boolean;
}

export const WaterfallConfigSummaryTable: React.FC<
  WaterfallConfigSummaryTableProps
> = ({
  fundFamilyId,
  commitmentId,
  investorClassId,
  fundId,
  startEditing,
  isEditing,
  readOnly,
}) => {
  const { data: waterfallConfigSummaryTable } =
    useWaterfallConfigTableRetrieveSuspense(fundFamilyId, {
      security_ownership_id: commitmentId,
      investor_class_id: investorClassId,
      entity_id: fundId,
    });
  // Hide edit menu if we are currently editing or in readOnly mode
  const hideEditMenu = isEditing || readOnly;
  const { t } = useTranslation(["common"]);
  return (
    <TableBox isFullWidth={true}>
      <TableBoxHeader>
        <TableBoxTitle>{t("common:waterfall")}</TableBoxTitle>
        <DataTableBoxActions
          endChildren={
            !hideEditMenu ? (
              <Restricted permission={PermissionTypeEnum.config}>
                <TableBoxActionsMenu>
                  <MenuItem onClick={startEditing}>{t("common:edit")}</MenuItem>
                </TableBoxActionsMenu>
              </Restricted>
            ) : null
          }
        />
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable data={waterfallConfigSummaryTable} />
      </TableBoxBody>
    </TableBox>
  );
};
